window.AppleWatch = (function($, fed) {
    'use strict';
    window.dataLayer = window.dataLayer || [];
    const self = {
        httpStatusCode: {
            ok: 200,
            created: 201,
            unprocessableEntity: 422,
            loginTimeout: 440,
            badGateway: 502
        },
        state: {
            url: '',
            continueButtonIsEnabled: false,
            selected: 'SELECTED',
            notStarted: 'NOT_STARTED',
            paid: 'PAID',
            dispatched: 'DISPATCHED'
        },
        elements: {
            buttons: {
                appleWatchSignUpButtonClick: '#sign-up-button',
                appleWatchTermsModal: '#apple-watch-terms-and-conditions-modal',
                appleWatchContinueButton: '#compliance-sign-up-button',
                appleWatchClickHereButton: '#apple-watch-click-here',
                appleWatchSignupButtonComponent: '#apple-watch-signup',
                appleWatchLaunchTableComponent: '.apple-watch-launch',
                guardedButtons: '.guarded-button',
                appleWatchTabSignupButtonClick: '.apple-watch-tab-sign-up-button',
                appStoreActionLink: '.app-store-action-link'
            },
            ids: {
                appleWatchErrorNotification: 'apple-watch-error',
                appleWatchSelectedNotification: 'apple-watch-selected',
                appleWatchTermsModal: 'apple-watch-terms-and-conditions-modal',
                appleWatchSignupButton: 'apple-watch-signup'
            },
            notifications: {
                appleWatchErrorNotification: '#apple-watch-error',
                appleWatchSelectedNotification: '#apple-watch-selected',
                appleWatchSignupNotification: '.sign-up-content'
            },
            checkboxes: {
                guards: '.checkbox-guard'
            },
            tabs: {
                appleWatchSeTab: '.apple-watch-se',
                appleWatchTab: '.apple-watch-tab'
            }
        },
        urls: {
            getMerchantSiteUrl:
                '/api/sitecore/AppleWatchSignup/GetMerchantSiteUrl',
            getSignupUrl:
                '/api/sitecore/AppleWatch/GetSignupUrl',
            getStatus:
                '/api/sitecore/AppleWatch/GetStatus',
            errorPage: '/error/error-page'
        },
        func: {
            init: function(viewData) {
                self.func.handleBankDetails();
                self.func.checkStatus.code(viewData);
                self.func.bindings();
            },
            appDownloadComponent: function()
            {
                $(self.elements.buttons.appStoreActionLink).removeClass('vds-item-hidden');
            },
            appleWatchTabProgramme: function(viewData) {
                self.func.handleBankDetails();
                self.func.helpers.hideItem(
                    self.elements.tabs.appleWatchSeTab
                );
                self.func.bindings();
                if ((viewData.toLowerCase() === self.state.dispatched.toLowerCase()) ||
                    (viewData.toLowerCase() === self.state.paid.toLowerCase())) {
                    self.func.helpers.hideItem(
                        self.elements.buttons.appleWatchTabSignupButtonClick
                    );
                    self.func.helpers.hideItem(
                        self.elements.notifications.appleWatchSignupNotification
                    );
                    if(viewData.toLowerCase() === self.state.paid.toLowerCase()){
                        self.func.helpers.hideItem(
                            self.elements.tabs.appleWatchSeTab
                        );
                        self.func.helpers.hideItem(
                            self.elements.tabs.appleWatchTab
                        );
                    }
                }
            },
            handleBankDetails: function()
            {
                $.ajax({
                    type: 'GET',
                    url: self.urls.getStatus,
                    success: self.func.getStatusSuccess,
                    error: self.func.getSignupUrlError
                });
            },
            getStatusSuccess:function(data) {
                if(data !== "True") {
                    $('.vds-partner-header__cta-container .vds-partner-header__button-primary').addClass("vds-button--disabled")
                    $(self.elements.buttons.appleWatchSignUpButtonClick).addClass('vds-button--disabled')
                }
                },
                bindings: function() {
                $(self.elements.buttons.appleWatchClickHereButton).on(
                    'click',
                    self.func.handleClickHere
                );
                $(self.elements.buttons.appleWatchContinueButton).on(
                    'click',
                    self.func.handleContinueButtonClick
                );
                $(self.elements.buttons.appleWatchSignUpButtonClick).on(
                    'click',
                    self.func.handleSignUpButtonClick
                );
                $(self.elements.buttons.appleWatchTabSignupButtonClick).on(
                    'click',
                    self.func.handleAppleWatchTabSignupButtonClick
                );
                $(self.elements.checkboxes.guards).on(
                    'click',
                    self.func.handleComplianceCheck
                );
                $(self.elements.buttons.appleWatchLaunchTableComponent)
                    .find('table thead tr th:nth-child(2)').hide();
                $(self.elements.buttons.appleWatchLaunchTableComponent)
                    .find('table tbody tr td:nth-child(2)').hide();
            },
            handleSignUpButtonClick: function() {
                self.func.openTermsModal();
            },
            handleContinueButtonClick: function() {
                if (self.state.isContinueButtonEnabled) {
                    $(self.elements.buttons.appleWatchContinueButton).addClass('vds-button--disabled');
                    self.func.getMerchantSiteUrl();
                }
            },
            handleClickHere: function() {
                self.func.getMerchantSiteUrl();
            },
            handleComplianceCheck: function() {
                self.func.handleGuardCheck(function(buttonEnabled) {
                    self.state.isContinueButtonEnabled = buttonEnabled;
                });
            },
            handleGuardCheck: function(callback) {
                // Guarded buttons become enabled once all guards are checked
                const uncheckedBoxes = $(
                    self.elements.checkboxes.guards + ':not(:checked)'
                );
                const allGuardsChecked = uncheckedBoxes.length === 0;

                $(self.elements.buttons.guardedButtons).each(function() {
                    if (allGuardsChecked) {
                        $(this).removeClass('vds-button--disabled');
                    } else {
                        $(this).addClass('vds-button--disabled');
                    }
                });

                if (callback) {
                    callback(allGuardsChecked);
                }
            },
            checkStatus: {
                code: function(viewData) {
                    if (viewData.toLowerCase() === self.state.selected.toLowerCase()) {
                        self.func.helpers.hideItem(
                            self.elements.buttons.appleWatchSignupButtonComponent
                        );
                        self.func.helpers.hideItem(
                            self.elements.ids.checkboxValidationTarget
                        );
                        self.func.helpers.showItem(
                            self.elements.notifications.appleWatchSelectedNotification
                        );
                        self.func.helpers.hideItem(
                            self.elements.notifications.appleWatchErrorNotification
                        );
                    }
                }
            },
            getMerchantSiteUrl: function() {
                $.ajax({
                    type: 'GET',
                    url: self.urls.getMerchantSiteUrl,
                    success: self.func.getMerchantSuccess,
                    error: self.func.getMerchantSiteUrlError
                });
            },
            getMerchantSuccess: function(data) {
                if (data.hasError || data.url === null) {
                    self.func.closeTermsModal();
                    self.func.helpers.showItem(
                        self.elements.notifications.appleWatchErrorNotification
                    );
                } else {
                    self.state.url = data.url;
                    self.func.redirectToUrl();
                }
            },
            getMerchantSiteUrlError: function(jqxhr) {
                if (jqxhr.statusCode === self.httpStatusCode.loginTimeout) {
                    self.func.helpers.reloadPage();
                } else {
                    jqxhr.func.redirectToErrorPage();
                }
            },
            redirectToUrl: function () {
                self.func.helpers.openInExistingTab(self.state.url);
            },
            redirectToErrorPage: function() {
                self.func.helpers.redirect(self.urls.errorPage);
            },
            openTermsModal: function() {
                self.func.helpers.openModal(
                    self.elements.ids.appleWatchTermsModal
                );
            },
            closeTermsModal: function() {
                self.func.helpers.closeModal(
                    self.elements.ids.appleWatchTermsModal
                );
            },
            helpers: {
                reloadPage: function() {
                    window.location.reload();
                },
                redirect: function(url) {
                    window.location.replace(url);
                },
                openPage: function(url) {
                    window.open(url, '_blank');
                },
                openInExistingTab: function (url) {
                    window.open(url, '_self');
                },
                openModal: function(id) {
                    fed.openModal(id);
                },
                closeModal: function(id) {
                    fed.closeModal(id);
                },
                showItem: function(identifier) {
                    $(identifier).show();
                },
                hideItem: function(identifier) {
                    $(identifier).hide();
                }
            },
            handleAppleWatchTabSignupButtonClick: function() {
                $.ajax({
                    type: 'GET',
                    url: self.urls.getSignupUrl,
                    success: self.func.getSignupUrlSuccess,
                    error: self.func.getSignupUrlError
                });
            },
            getSignupUrlSuccess: function(data) {
                if (data === null) {
                    self.func.helpers.redirect(self.urls.errorPage);
                } else {
                    self.state.url = data;
                    self.func.redirectToUrl();
                }
            },
            getSignupUrlError: function() {
                self.func.helpers.redirect(self.urls.errorPage);
            }
        }
    };

    return {
        Init: self.func.init,
        appleWatchTabProgramme: self.func.appleWatchTabProgramme,
        appDownloadComponent: self.func.appDownloadComponent
    };
})(window.jQuery, { openModal: window.openModal, closeModal: window.closeModal });

$('document').ready(function() {
    if ('applewatch' === $('#page-data').data('feature')) {
        let viewData = $('#page-data').data('status');
        window.AppleWatch.Init(viewData);
    }
    if ('applewatchprogramme' === $('#page-data').data('feature')) {
        let viewData = $('#page-data').data('status');
        window.AppleWatch.appleWatchTabProgramme(viewData);
    }
    if ('applewatchtracking' === $('#page-data').data('feature') ||
        'applewatchdelivery' === $('#page-data').data('feature')) {
        window.AppleWatch.appDownloadComponent();
    }
});

